<template>
  <div class="main-body">
    <div class="page-attention">
      <p>创建参数名称后在管理中编辑属性</p>
    </div>
    <a-divider />
    <a-form :model="formState" autocomplete="off" :label-col="labelCol" :wrapper-col="wrapperCol" @finish="onSubmit">
      <a-form-item label="参数名称" name="class_name" :rules="[{ required: true, message: '请输入标签名称!' }]">
        <a-input class="half-input" v-model:value="formState.class_name" placeholder="请输入标签名称" />
      </a-form-item>
      <a-form-item label="排序" name="sort" extra="数字越大，排序越靠前，数字重复，则最新添加的靠前。">
        <a-input-number class="medium-input" v-model:value="formState.sort" :min="0" :max="1000000" />
      </a-form-item>
      <a-form-item class="form-submit-layout">
        <a-button type="primary" html-type="submit">保存</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { defineComponent, reactive } from "vue";

export default defineComponent({
  setup() {
    const formState = reactive({
      class_name: "",
      sort: "0",
    });

    const onSubmit = () => {};

    return {
      labelCol: {
        style: {
          width: "100px",
        },
      },
      labelColSecond: {
        style: {
          width: "44px",
        },
      },
      wrapperCol: {
        span: 7,
      },
      formState,
      onSubmit,
    };
  },
});
</script>